import styled from "styled-components";
import { Menu } from "antd";

import colors from "../_style/color";

export default styled(Menu)`
  border: 0;

  .ant-menu-item {
    display: inline-block;
    width: calc(100% / 14);
    padding: 0;
    margin: 0 !important;
    height: auto !important;
    line-height: auto !important;
  }

  .ant-menu-item:active,
  .ant-menu-item:hover {
    background-color: unset;
    color: unset;
  }

  :not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${colors.primary};
    color: ${colors.light};
    border-radius: 2px;
  }
`;
